import { apiClient } from './apiClient';
import { ServiceOnlyPage } from '../types/serviceOnlyPage';

// Backend API response for list endpoint (simplified)
interface ServiceOnlyPageListItem {
  id: string;
  crew_run_id: string;
  service_name: string;
  target_keyword?: string;
  slug: string;
  status: string;
  progress_percentage?: number;
  current_stage?: string;
  wordpress_post_url?: string;
  gdocs_url?: string;
  has_content: boolean;
  created_at: string;
  published_at?: string;
}

function mapListItemToServiceOnlyPage(item: ServiceOnlyPageListItem): ServiceOnlyPage {
  return {
    id: item.id,
    crew_run_id: item.crew_run_id,
    tenant_id: '', // Not returned in list response, filled by caller
    service_name: item.service_name,
    target_keyword: item.target_keyword,
    slug: item.slug,
    status: item.status as ServiceOnlyPage['status'],
    progress_percentage: item.progress_percentage,
    current_stage: item.current_stage,
    wordpress_post_url: item.wordpress_post_url,
    gdocs_url: item.gdocs_url,
    created_at: item.created_at,
    published_at: item.published_at,
  };
}

export const serviceOnlyPageService = {
  async list(tenantId: string, _status?: string): Promise<ServiceOnlyPage[]> {
    const { data } = await apiClient.get<ServiceOnlyPageListItem[]>(
      '/service-only-pages/',
      { params: { tenant_id: tenantId } },
    );
    return (data ?? []).map((item) => ({
      ...mapListItemToServiceOnlyPage(item),
      tenant_id: tenantId,
    }));
  },

  async get(id: string): Promise<ServiceOnlyPage> {
    const { data } = await apiClient.get<ServiceOnlyPage>(
      `/service-only-pages/${id}`,
    );
    return data;
  },

  async generateWithCrew(inputs: {
    service: string;
    keyword?: string;
    tenant_id: string;
    existing_page_id?: string;
  }) {
    const { data } = await apiClient.post(
      '/service-only-pages/generate',
      {
        tenant_id: inputs.tenant_id,
        service_name: inputs.service,
        target_keyword: inputs.keyword,
      },
      { timeout: 300_000 },
    );
    return data;
  },

  async update(id: string, updateData: Partial<ServiceOnlyPage>): Promise<ServiceOnlyPage> {
    const { data } = await apiClient.patch<ServiceOnlyPage>(
      `/service-only-pages/${id}`,
      updateData,
    );
    return data;
  },

  async delete(id: string) {
    const { data } = await apiClient.delete(`/service-only-pages/${id}`);
    return data;
  },

  async publish(id: string) {
    const { data } = await apiClient.post(`/service-only-pages/${id}/publish`);
    return data;
  },
};
